import React from 'react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import { fg } from '@atlassian/jira-feature-gating';
import EmptySlaSvg from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/empty/components/empty-no-clock';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import DeprecatedEmptySlaSvg from './assets/sla-empty-background.svg';
import messages from './messages';

export type Props = {
	onAdd: () => void;
};

const MAX_IMAGE_SIZE = 600;
const MAX_IMAGE_WIDTH = 202;
const MAX_IMAGE_HEIGHT = 246;
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ onAdd }: Props) => {
	const { formatMessage } = useIntl();

	if (fg('consolidate_bumblebee_jfe_assets')) {
		return (
			<>
				<EmptyState
					header=""
					size="wide"
					maxImageWidth={MAX_IMAGE_WIDTH}
					maxImageHeight={MAX_IMAGE_HEIGHT}
					renderImage={getAkEmptyStateRenderImageFn(EmptySlaSvg)}
					isLoading={false}
					primaryAction={
						<Button
							appearance="primary"
							isDisabled={false}
							onClick={onAdd}
							testId="servicedesk-sla-settings.ui.empty-view.add-sla"
						>
							{formatMessage(messages.addSla)}
						</Button>
					}
				/>
			</>
		);
	}

	return (
		<>
			<EmptyState
				header=""
				size="wide"
				maxImageWidth={MAX_IMAGE_SIZE}
				maxImageHeight={MAX_IMAGE_SIZE}
				imageUrl={DeprecatedEmptySlaSvg}
				isLoading={false}
				primaryAction={
					<Button
						appearance="primary"
						isDisabled={false}
						onClick={onAdd}
						testId="servicedesk-sla-settings.ui.empty-view.add-sla"
					>
						{formatMessage(messages.addSla)}
					</Button>
				}
			/>
		</>
	);
};
